// Texts for the world 'henhouse': name on the map and the level titles, per language.
// The ids must be the level ids in levels.ts (npm run validate checks it); other languages must have the same ids as da (tsc).
import { defineWorldStrings } from '../../core/i18n';

export const strings = defineWorldStrings({
  da: {
    name: 'Hønsegården',
    scene: { cluck: 'KLUK!', cheep: 'PIP!' },
    levels: {
      'thump': { title: 'Dunk' },
      'feather': { title: 'Fjer' },
      'hen': { title: 'Høne' },
      'far-out': { title: 'Langt ude' },
      'middle': { title: 'Midten' },
      'heavy-enough': { title: 'Tung nok' },
      'place-the-seesaw': { title: 'Sæt vippen' },
      'flip-the-seesaw': { title: 'Vend vippen' },
      'over-the-fence': { title: 'Over hegnet' },
      'two-eggs': { title: 'To æg' },
      'flip-and-move': { title: 'Vend og flyt' },
      'under-the-roof': { title: 'Under taget' },
      'egg-tray': { title: 'Æggebakken' },
      'pumpkin': { title: 'Græskarret' },
      'master': { title: 'Mester' },
    },
  },
  en: {
    name: 'The hen yard',
    scene: { cluck: 'CLUCK!', cheep: 'CHEEP!' },
    levels: {
      'thump': { title: 'Thump' },
      'feather': { title: 'Feather' },
      'hen': { title: 'Hen' },
      'far-out': { title: 'Far out' },
      'middle': { title: 'The middle' },
      'heavy-enough': { title: 'Heavy enough' },
      'place-the-seesaw': { title: 'Place the seesaw' },
      'flip-the-seesaw': { title: 'Flip the seesaw' },
      'over-the-fence': { title: 'Over the fence' },
      'two-eggs': { title: 'Two eggs' },
      'flip-and-move': { title: 'Flip and move' },
      'under-the-roof': { title: 'Under the roof' },
      'egg-tray': { title: 'The egg box' },
      'pumpkin': { title: 'The pumpkin' },
      'master': { title: 'Master' },
    },
  },
});
